import * as Yup from 'yup';

export const validationSchema = ({ t }) => {
  const isRequired = t('is required');
  const billingInfo = t('Billing info -');
  const valid = t('must be a valid');

  const messages = {
    firstName: `${billingInfo} ${t('First name')} ${isRequired}`,
    lastName: `${billingInfo} ${t('Last name')} ${isRequired}`,
    phone: `${billingInfo} ${t('Phone number')} ${isRequired}`,
    email: `${billingInfo} ${t('Email')} ${isRequired}`,
    address1: `${billingInfo} ${t('Address')} ${isRequired}`,
    city: `${billingInfo} ${t('City')} ${isRequired}`,
    state: `${billingInfo} ${t('State')} ${isRequired}`,
    postalCode: `${billingInfo} ${t('Zip code')} ${isRequired}`,
    country: `${billingInfo} ${t('Country')} ${isRequired}`,
    validPhone: `${billingInfo} ${t('Phone number')} ${valid} ${t('phone')}`,
    invalidPostalCode: `${t('Zip code')} ${valid} ${t('zip code')}`,
    billTo: `${t('Bill to')} ${isRequired}`,
    companyName: `${t('Company')} ${isRequired}`
  };

  return Yup.object().shape({
    billTo: Yup.string()
      .required(messages.billTo)
      .typeError(messages.billTo),
    companyName: Yup.string()
      .nullable()
      .when('billTo', {
        is: 'THIRD_PARTY',
        then: Yup.string()
          .typeError(messages.companyName)
          .required(messages.companyName)
      }),
    billToContactInfo: Yup.object().when('billTo', {
      is: 'THIRD_PARTY',
      then: Yup.object({
        firstName: Yup.string()
          .typeError(messages.firstName)
          .required(messages.firstName),
        lastName: Yup.string()
          .typeError(messages.lastName)
          .required(messages.lastName),
        phone: Yup.string()
          .phone(messages.validPhone)
          .typeError(messages.phone)
          .required(messages.phone),
        email: Yup.string()
          .email(`${billingInfo} ${t('Email is invalid')}`)
          .typeError(messages.email)
          .required(messages.email)
      })
    }),
    billToAddress: Yup.object().when('billTo', {
      is: 'THIRD_PARTY',
      then: Yup.object({
        address1: Yup.string()
          .typeError(messages.address1)
          .required(messages.address1),
        city: Yup.string()
          .typeError(messages.city)
          .required(messages.city),
        state: Yup.string()
          .typeError(messages.state)
          .required(messages.state),
        postalCode: Yup.string()
          .zip(messages.invalidPostalCode)
          .typeError(messages.postalCode)
          .required(messages.postalCode),
        country: Yup.string()
          .typeError(messages.country)
          .required(messages.country)
      })
    })
  });
};

export default validationSchema;
